import React from "react";

const Loader = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div class="chaotic-orbit"></div>{" "}
    </div>
  );
};

export default Loader;
